var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('title-comp'),_c('about-comp'),_c('projects-comp'),_c('Skills'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }